// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"396": "7867ed7a","512": "2a878ab8","75": "630edede",}[chunkId] + ".js"
}